import { useState } from "react";
import { MosaicWindow } from "react-mosaic-component";
import { Box } from "@mui/material";
import { MosaicBranch } from "react-mosaic-component/src/types.ts";
import { AavoMosaicWindowToolbar } from "./AavoMosaicWindowToolbar";
import { AavoMosaicTabWithKey } from "src/components/common/mosaic/types.ts";

export interface AavoMosaicWindowProps {
	tabKey: string;
	path: MosaicBranch[];
	tabsByKeys: Record<string, AavoMosaicTabWithKey>;
	resetLayout: () => void;
}

export const AavoMosaicWindow = ({
	tabKey,
	path,
	tabsByKeys,
	resetLayout,
}: AavoMosaicWindowProps) => {
	const tab = tabsByKeys[tabKey];
	const [activeItemIndex, setActiveItemIndex] = useState<number>(tab?.selectedIndex ?? 0);

	if (tab === undefined) {
		// Layout has changed and saved layout is no longer valid.
		// Reset will restore the initial layout.
		resetLayout();
		return null;
	}

	return (
		<MosaicWindow
			title={""}
			path={path}
			draggable={false}
			renderToolbar={() => (
				<AavoMosaicWindowToolbar
					items={tab.items}
					activeItemIndex={activeItemIndex}
					setActiveItemIndex={(index) => {
						setActiveItemIndex(index);
						tab?.onActiveItemChanged?.(index);
					}}
				/>
			)}
		>
			<Box
				sx={{
					flex: 1,
					display: "flex",
					height: "100%",
				}}
			>
				{tab.items.map((item, index) => (
					<Box
						key={index}
						sx={{
							flex: 1,
							display: activeItemIndex === index ? "flex" : "none",
						}}
					>
						{item.content}
					</Box>
				))}
			</Box>
		</MosaicWindow>
	);
};
